// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"213":"b3949530","333":"31d6cfe0"}[chunkId] + ".chunk.css";
};